import React from 'react'
import OneCategoryDIscountListContainer from '../../../../../Components/DiscountPart/DiscountListsContainer/OneCategoryDIscountListContainer/OneCategoryDIscountListContainer'
import Layout from '../../../Layout'
const OneCategoryDiscountList = () => {
  return (
    <Layout>
      <OneCategoryDIscountListContainer/>
    </Layout>
  )
}

export default OneCategoryDiscountList